import { ReactElement } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import Card from '@10xLabs/react-web/components/Card'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedRoute } from '@10xLabs/react-web/components/FormattedRoute'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import Heading from 'components/v2/Heading'
import { ContentHeader } from 'components/v2/Content'
import { ILegSegmentsDropdownProps, ITripIncidenceCouponsContentProps } from './types'
import { TripIncidenceCouponsList } from '../TripIncidenceCouponsList'
import { Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { Dropdown } from 'components/v2/Dropdown'

const StyledTable = styled(Table)<TSFixMe>`
  font-size: 14px;
  font-weight: 400;
`
const CountContainer = styled.div<TSFixMe>`
  display: flex;
  gap: 5px;
`

const Flex = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
`
const PassengerCount = styled.div<TSFixMe>`
  color: red;
`
const HeaderWrapper = styled.div<TSFixMe>`
  display: flex;
  flex-wrap: wrap;
  margin: -3px -30px;

  > * {
    margin: 3px 30px;
  }
`
const StyledButton = styled.button<TSFixMe>`
  background: none;
  border: none;
  color: #47c5d5;
  cursor: pointer;
  font-size: inherit;
  font-weight: inherit;
  padding: 0;
  text-decoration: underline;
`

const LegSegmentsDropdown = ({ legSegments }: ILegSegmentsDropdownProps): ReactElement => {
  return (
    <Dropdown toggle={<StyledButton>{legSegments?.length}</StyledButton>} noPadding fitContent>
      <StyledTable>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="dictionary.origin" defaultMessage="Origin" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.destination" defaultMessage="Destination" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {legSegments.map(({ origin, destination }, index): TSFixMe => {
            return (
              <Tr key={index}>
                <Td>{origin?.name}</Td>
                <Td>{destination?.name}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </StyledTable>
    </Dropdown>
  )
}

export const TripIncidenceCouponsContent = ({ subcampaign }: ITripIncidenceCouponsContentProps): ReactElement => {
  const intl = useIntl()
  return (
    <>
      <ContentHeader>
        <Heading.H4>
          <HeaderWrapper>
            <div>
              <FormattedMessage
                id="trips.passengers.routeServiceCode.title"
                defaultMessage="Trip {routeServiceCode}"
                values={{
                  routeServiceCode: subcampaign.trip?.routeService.code
                }}
              />
            </div>
            <div>
              <FormattedRoute origin={subcampaign.trip?.origin} destination={subcampaign.trip?.destination} />
            </div>
            <Flex>
              <FormattedDate
                intl={intl}
                value={subcampaign.trip?.departureAt}
                month="2-digit"
                day="2-digit"
                year="numeric"
              />
              &nbsp;
              <FormattedTimeByDate intl={intl} date={subcampaign.trip?.departureAt} />
            </Flex>
            <CountContainer>
              <span>Affected passengers:</span>
              <PassengerCount>
                {subcampaign.coupons.reduce((acc, coupon): TSFixMe => {
                  return acc + (coupon.originalBooking?.passengersCount ?? 0)
                }, 0)}
              </PassengerCount>
            </CountContainer>
            <CountContainer>
              <span>Impacted legs:</span>
              <LegSegmentsDropdown legSegments={subcampaign.trip?.affectedLegSegments ?? []} />
            </CountContainer>
          </HeaderWrapper>
        </Heading.H4>
      </ContentHeader>
      <Card.Container>
        <Card.Content noHeader noFooter>
          <TripIncidenceCouponsList
            coupons={subcampaign?.coupons ?? []}
            campaignId={subcampaign.campaignID}
            subcampaignId={subcampaign.id}
          />
        </Card.Content>
      </Card.Container>
    </>
  )
}
